import { useContext } from 'react'
import { Service as ServiceInterface } from "../../others/accomodation.interfaces"
import { uniqueId } from "../../others/oneliners";
import { BookingContext, bookingContext } from '../../pages/AccomodationPage';
import Btn from "../Btn";
import Img from "../Img";

interface ServiceProps extends ServiceInterface {
    skeleton?: boolean;
    small?: boolean;
}



const Service = (props: ServiceProps): JSX.Element => {
    const { setBook } = useContext<BookingContext>(bookingContext);
    return (
        <div className={`Service relative flex ${props.small ? 'flex-row h-[110px]' : 'flex-col'} gap-1 w-fit max-w-xs rounded-xl  opacity-100 sm:opacity-60 hover:opacity-100 hover:bg-slate-100 cursor-pointer`}>
            <Img
                src={props.thumbnail + '?random=' + uniqueId()}
                alt={`Service-${props.title}`}
                className={`${props.small ? 'min-h-full h-[unset] w-[110px]' : 'h-[200px] w-[320px] '} rounded-xl`}
            />
            <div className={`flex flex-col ${!props.small && 'pb-16'} relative px-3 pt-2`}>
                {props.small ? <h4 className={`pr-4`}>{props.title}</h4> : <h3 className={`pr-4`}>{props.title}</h3>}
                <p className={`text-gray-400 text-sm ${props.small && 'w-[200px] overflow-x-hidden text-ellipsis whitespace-nowrap'}`}>{props.description}</p>
                <h3 className={`text-darkblue ${props.small ? '' : 'absolute top-1 right-3'}`}>{props.price.currency} {props.price.ammount}</h3>
            </div>
            <Btn className={`Service-Btn w-fit py-3 px-9 rounded-full absolute bottom-2 sm:-bottom-full ${props.small ? 'right-2' : 'left-2'}`} filled onClick={() => setBook!(true)}>Book</Btn>
        </div>
    )
}

export default Service

export const ServiceSmall = (props: ServiceProps) => {
    return (
        <div className={`Service relative flex ${props.small ? 'flex-row' : 'flex-col'} gap-1 w-fit max-w-xs rounded-xl pb-16 opacity-100 sm:opacity-60 hover:opacity-100 hover:bg-slate-100 cursor-pointer`}>
            <Img
                src={props.thumbnail + '?random=' + uniqueId()}
                alt={`Service-${props.title}`}
                className={`${props.small ? 'h-[80px] w-[80px]' : 'h-[200px] w-[320px]'} rounded-xl`}
            />
            <div className="flex items-center gap-3 justify-between p-3">
                <h3>{props.title}</h3>
                <h3 className="text-darkblue">{props.price.currency} {props.price.ammount}</h3>
            </div>
            <p className="text-gray-400 text-sm px-3">{props.description}</p>
            <Btn className="Service-Btn w-fit py-3 px-9 rounded-full absolute bottom-2 sm:-bottom-full left-2" filled>Book</Btn>
        </div>
    )
}

export const ServiceSkeleton = (): JSX.Element => {
    return <></>
}